import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import skills from '../data/skills'

export default () => {
    return (
        <Styles>
            <h1 className="skill-heading"><b>Skills</b></h1>
            <Container className="skill-container">
                <Row>
                    <Col xs={12} md={4}>
                        <h3><b>Web Development</b></h3>
                        <ul>
                            {skills.web_dev.map((wd) => <li key={wd}>{wd}</li>)}
                        </ul>
                    </Col>
                    <Col xs={12} md={4}>
                        <h3><b>Data Science</b></h3>
                        <ul>
                            {skills.data_science.map((ds) => <li key={ds}>{ds}</li>)}
                        </ul>
                    </Col>
                    <Col xs={12} md={4}>
                        <h3><b>Soft Skills</b></h3>
                        <ul>
                            {skills.soft_skills.map((ss) => <li key={ss}>{ss}</li>)}
                        </ul>
                    </Col>
                </Row>
            </Container>
        </Styles >
    )

}



const Styles = styled.div`
.skill-container{
    background-color: #87C4C1;
    color:white;
    padding:4% 6% 4% 6%;
}
.skill-heading{
    text-align:center;
    padding-top:5%;
    color:#45908B;
    margin-bottom:2rem;
}

@media (min-width: 1920px) {
    .skill-container{
        max-width: 65%;
    }
    li{
        font-size: 130%;
    }

}

`
